import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"

import { API_OPERATIONS_URL } from "../constants"
import { IOperationItem } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"


async function fetchOperation(token: string | null, operationId: string) {
  const response = await axios(`${API_OPERATIONS_URL}/${operationId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
  
  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка при получении деталей операции")
  }

  return response.data
}

export const useGetOperationHistoryDetails = (operationId: string) => {
  const token = useSelector((state: RootState) => state.auth.token)
  const { data } = useQuery<IOperationItem>({
    queryKey: ["operation-details", operationId],
    queryFn: () => fetchOperation(token, operationId),
  })
  let operation: IOperationItem | null = null
  if (data) {
    operation = data
  }
  return {
    data: operation
  }
}